import {
  DASHBOARD_MENU_AVAILABLE_BEGIN,
  DASHBOARD_MENU_AVAILABLE_FAILURE,
  DASHBOARD_MENU_AVAILABLE_SUCCESS,
} from "./1_ActionConstants";

export const begin = () => ({
  type: DASHBOARD_MENU_AVAILABLE_BEGIN,
});

export const success = (value) => ({
  type: DASHBOARD_MENU_AVAILABLE_SUCCESS,
  payload: value,
});

export const failure = (error) => ({
  type: DASHBOARD_MENU_AVAILABLE_FAILURE,
  payload: { error },
});

export function updateIsDashboardAvailable(value) {
  return (dispatch, getState) => {
    //redux passes dispatch & getState as args into thunk functions
    dispatch(begin());
    if (value) {
      dispatch(success(value));
      return true;
    } else {
      dispatch(failure("error"));
      return false;
    }
  };
}
